import React from 'react';
import {
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Area,
	AreaChart
} from 'recharts';

export default function AveragesChart({
	averageEnrichPerDay,
	colors,
}) {
	return (
		<AreaChart
			className="areaChartRechart"
			width={600}
			height={400}
			data={averageEnrichPerDay}
			margin={{ top: 10, right: 30, left: 0, bottom: 15 }}
		>
			<XAxis dataKey="date" />
			<YAxis />
			<CartesianGrid strokeDasharray="3 3" />
			<Tooltip />
			<Area
				type="monotone"
				dataKey="Average Length Of Each Enrichment Today"
				stroke="black"
				fill={colors[3]}
			/>
			<Area
				type="monotone"
				dataKey="Average Total Time Out Of Cage Today"
				stroke="black"
				fill={colors[4]}
			/>
		</AreaChart>
	);
}
